export default {
      id: "icon-sorting-up-usage",
      viewBox: "0 0 8 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-sorting-up",
      toString: function () {
        return this.url;
      }
    }